export default "__VITE_ASSET__B3$4VvWV__"